interface ErrorMsgProps {
  message: string;
  show?: boolean;
}

const ErrorMsg = ({ message, show = false }: ErrorMsgProps) => {
  if (!show) {
    return null;
  }
  return (
    <div className={`text-[#FF3E41]   text-[12px] font-['Mulish'] font-[700]`}>
      {message}
    </div>
  );
};
export default ErrorMsg;
